import { z } from 'zod';
import { Validation } from '@mews/framework';
import { updateSchema as commonUpdateSchema } from '../common/schemas';

export const schema = z.object({
    name: Validation.String.Empty.default(''),
    companyName: Validation.String.Empty.default(''),
    taxIdentificationNumber: Validation.String.Empty.default(''),
});

export type FormValues = z.infer<typeof schema>;

export const updateSchema = schema.merge(commonUpdateSchema);

export type UpdateFormValues = z.infer<typeof updateSchema>;
export type UpdateFormValuesInput = z.input<typeof updateSchema>;
